import authSteps, { AuthFlowType } from '../containers/AuthContainer/authSteps';

const {
  PHONE,
  VERIFY_PHONE,
  VERIFY_EMAIL,
  EMAIL_CODE,
  HELP_EMAIL,
  HELP,
  LOGIN_EMAIL_PASSWORD,
  SIGNUP,
  SIGNUP_PHONE,
  CAPTURE_EMAIL,
  SUCCESS_VIEW,
  CELEBRATION,
} = authSteps;

export const goBack = (state) => {
  const { history, authFlowType } = state;
  history.pop();

  return {
    ...state,
    errorMessage: null,
    authFlowType: (history[history.length - 1] === PHONE ? AuthFlowType.DEFAULT : authFlowType),
    currentStep: history[history.length - 1],
    history: [...history],
  };
};

export const setMobileClaim = (props) => (
  (state) => {
    const { user, user: { phone } } = state;
    return {
      ...state,
      user: {
        ...user,
        phone: {
          ...phone,
          claimToken: props.claim_token,
        },
        email: null,
      },
      authFlowType: AuthFlowType.DEFAULT,
      errorMessage: null,
    };
  }
);

export const setEmailClaim = (props) => (
  (state) => {
    const { user } = state;
    return {
      ...state,
      user: {
        ...user,
        emailClaimToken: props.claim_token,
      },
      authFlowType: AuthFlowType.DEFAULT,
      errorMessage: null,
    };
  }
);

export const showLoginView = (state) => ({
  ...state,
  currentStep: LOGIN_EMAIL_PASSWORD,
  history: [
    ...state.history,
    LOGIN_EMAIL_PASSWORD,
  ],
  authFlowType: AuthFlowType.DEFAULT,
  errorMessage: null,
});

export const showCaptureEmailView = (state) => ({
  ...state,
  currentStep: CAPTURE_EMAIL,
  history: [
    ...state.history,
    CAPTURE_EMAIL,
  ],
  authFlowType: AuthFlowType.DEFAULT,
  errorMessage: null,
});

export const showEmailCodeVerificationView = (state, updatedUser) => ({
  ...state,
  user: updatedUser,
  currentStep: EMAIL_CODE,
  history: [
    ...state.history,
    EMAIL_CODE,
  ],
  authFlowType: AuthFlowType.DEFAULT,
  errorMessage: null,
});

export const showSignupWithPhoneView = (state, authFlowType = AuthFlowType.DEFAULT) => ({
  ...state,
  currentStep: SIGNUP_PHONE,
  history: [
    ...state.history,
    SIGNUP_PHONE,
  ],
  authFlowType,
  errorMessage: null,
});

export const showSignupView = (state) => ({
  ...state,
  currentStep: SIGNUP,
  history: [
    ...state.history,
    SIGNUP,
  ],
  authFlowType: AuthFlowType.DEFAULT,
  errorMessage: null,
});

export const showSuccessView = (state, updatedUser) => ({
  ...state,
  user: updatedUser,
  currentStep: SUCCESS_VIEW,
  history: [
    ...state.history,
    SUCCESS_VIEW,
  ],
  authFlowType: AuthFlowType.DEFAULT,
  errorMessage: null,
});

export const showHelpView = (state) => ({
  ...state,
  currentStep: HELP,
  history: [
    ...state.history,
    HELP,
  ],
  authFlowType: AuthFlowType.DEFAULT,
  errorMessage: null,
});

export const showHelpEmailView = (state) => ({
  ...state,
  currentStep: HELP_EMAIL,
  history: [
    ...state.history,
    HELP_EMAIL,
  ],
  authFlowType: AuthFlowType.DEFAULT,
  errorMessage: null,
});

export const showVerifyPhoneView = (props) => (
  (state) => {
    const { history, user } = state;
    return {
      ...state,
      currentStep: VERIFY_PHONE,
      history: [
        ...history,
        VERIFY_PHONE,
      ],
      user: {
        ...user,
        phone: props.phone,
      },
      captcha: props.captcha,
      authFlowType: props.authFlowType,
      errorMessage: null,
    };
  }
);

export const showEmailCodeChallengeView = (state, updatedUser) => ({
  ...state,
  user: updatedUser,
  currentStep: EMAIL_CODE,
  history: [
    ...state.history,
    EMAIL_CODE,
  ],
  authFlowType: AuthFlowType.DEFAULT,
  errorMessage: null,
});

export const showChallengeView = (props) => (
  (state) => {
    const { history, user } = state;
    return {
      ...state,
      currentStep: VERIFY_EMAIL,
      history: [
        ...history,
        VERIFY_EMAIL,
      ],
      user: {
        ...user,
        firstName: props.first_name,
        challengeId: props.challenge_id,
      },
      authFlowType: AuthFlowType.DEFAULT,
      errorMessage: null,
    };
  }
);

export const showCelebrationView = (state) => ({
  ...state,
  currentStep: CELEBRATION,
  history: [
    ...state.history,
    CELEBRATION,
  ],
  authFlowType: AuthFlowType.DEFAULT,
  errorMessage: null,
});
